import { Navigate, useParams } from "react-router-dom";
import {
  MarketingNewsletterCard,
  MarketingNewsletterFormContainer,
} from "@platform/features/marketing";
import { NewsPostContainer, NewsSectionContainer } from "@platform/features/news";

/** One post, then the News section and Get Updates, as the design ends it. */
export default function NewsPostPage() {
  return (
    <>
      <NewsPostContainer />
      <NewsSectionContainer>
        <MarketingNewsletterCard>
          <MarketingNewsletterFormContainer className="w-full" />
        </MarketingNewsletterCard>
      </NewsSectionContainer>
    </>
  );
}

/** A post's address from when the section was called the blog. */
export function BlogPostRedirect() {
  const { slug } = useParams<{ slug: string }>();
  return <Navigate to={`/news/${slug ?? ""}`} replace />;
}
